// extracted by mini-css-extract-plugin
module.exports = {"root":"back-button_root__rLvXf","selectedSubMenu":"back-button_selectedSubMenu__OLB4S","searchPage":"back-button_searchPage__Dvdg0"};